import Vue from 'vue';

Vue.filter('discount', value => {
    
    let discount = window.theme.storewideDiscountEnable ? (100 - window.theme.storewideDiscountAmount) * 0.01 : 1;

    if(value){
        return (Math.ceil(value * discount));
    } else{
        return 0;
    }
});
